import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CombinedOrderRequest, OrderData, OrderPlacement, OrderRequest } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { UserExperienceData } from '../entities/user-experience-data.entity';

@Injectable({ providedIn: 'root' })
export class TradeInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #api = `${environment.apihost}/api`;

  public verifyOrder(orderData: OrderRequest) {
    return this.#http.post(`${this.#api}/trading/order/verify`, orderData);
  }

  public validateCombinedOrder(combinedOrderRequest: CombinedOrderRequest) {
    return this.#http.post<OrderData[]>(
      `${environment.apihost + environment.tradingServiceUrl}/combinedorder/validate`,
      combinedOrderRequest,
    );
  }

  public placeOrder(request: OrderRequest) {
    return this.#http.post<OrderPlacement>(`${environment.apihost + environment.tradingServiceUrl}/order`, request);
  }

  public placeCombinedOrder(request: CombinedOrderRequest) {
    return this.#http.post<OrderPlacement>(`${environment.apihost + environment.tradingServiceUrl}/combinedorder/create`, request);
  }

  public loadKnowledgeAndExperienceForm(isins: string[]): Observable<UserExperienceData> {
    return this.#http.get<UserExperienceData>(`${this.#api}/user-experience/show-form`, { params: { isins } });
  }

  public submitKnowledgeAndExperienceForm(userExperienceData: UserExperienceData) {
    return this.#http.post<UserExperienceData>(`${this.#api}/user-experience/save-experience`, userExperienceData);
  }
}
